<nz-card nzTitle="Mould Decision Tool" [nzExtra]="extraTemplate">
  <nz-skeleton [nzActive]="true" [nzLoading]="(loading$ | async) ?? false">
    <ng-container *ngIf="error$ | async as errorMsg; else resultTemplate">
      <nz-result
        nzStatus="error"
        nzTitle="SharePoint gave an error"
        [nzSubTitle]="errorMsg"
      ></nz-result>
    </ng-container>

    <ng-template #extraTemplate>
      <!-- Use stopPropagation so the panel doesn't toggle when clicking the link -->
      <a target="_blank" rel="external" [href]="siteUrl" (click)="$event.stopPropagation()">
        <i nz-icon nzType="link"></i>
        Open SharePoint Site
      </a>
    </ng-template>
  </nz-skeleton>
</nz-card>

<ng-template #resultTemplate>
  <ng-container *ngIf="mdt$ | async as mdt; else noData">
    <nz-descriptions [nzColumn]="4" nzLayout="vertical">
      <nz-descriptions-item nzTitle="Order type">
        <em-display-property [value]="mdt.orderType"></em-display-property>
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="UGS code">
        <em-display-property [value]="mdt.ugsCode"></em-display-property>
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Financial recommendation">
        <em-display-property [value]="mdt.financialRecommendation"></em-display-property>
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Selected proposal">
        <em-display-property [value]="mdt.selectedProposal"></em-display-property>
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Comment">
        <em-display-property [value]="mdt.comment"></em-display-property>
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Mould layout">
        <em-display-property [value]="mdt.mouldLayout"></em-display-property>
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Mould type">
        <em-display-property [value]="mdt.mouldType"></em-display-property>
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Elements">
        <em-display-property [value]="mdt.elements"></em-display-property>
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Cycletime">
        <em-display-property [value]="mdt.cycletime"></em-display-property>
      </nz-descriptions-item>

      <nz-descriptions-item nzTitle="Mould price">
        <em-display-property [value]="mdt.mouldPrice"></em-display-property>
      </nz-descriptions-item>
    </nz-descriptions>

    <div nz-row nzJustify="end">
      <a target="_blank" rel="external" [href]="mdt.webUrl">
        <em-display-property [value]="mdt.fileName"></em-display-property>
        <i class="icon" nz-icon nzType="file-excel" nzTheme="twotone" nzTwotoneColor="5914fa"></i>
      </a>
    </div>
  </ng-container>
</ng-template>

<ng-template #noData>
  <nz-empty></nz-empty>
</ng-template>
